"use client";
import Navigation from "@/HomeFeatures/Navigation";
import Image from "next/image";
import { usePageAnimations } from "@/hooks/usePageAnimations";
import { Icons, Images } from "@assets/assets";
import PrimaryBtn from "@/components/PrimaryBtn";

export default function Notfound() {
  usePageAnimations();

  return (
    <>
      <section className="relative  min-h-screen w-full flex flex-col bg-[#0b46ef] overflow-hidden">
        <div className="absolute inset-0 ">
          <Image
            src={Images?.thankyouBackcircle}
            alt="background"
            fill
            className="object-contain"
            sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
            priority
          />
        </div>
        <div className="relative z-30">
          <Navigation />
        </div>
        {/* Hero Content */}
        <div className="flex-grow flex flex-col items-center justify-center text-center px-6 relative z-10">
          <div className="relative mb-10 group">
            <div className="absolute inset-0 bg-blue-400/20 blur-[60px] rounded-full" />
            <div className="">
              <div className="relative w-50 h-50 md:w-100 md:h-50">
                <Image
                  src={Images?.fourzerofour}
                  alt="Success Icon"
                  fill
                  className="object-contain"
                  priority
                  fetchPriority="high"
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                />
              </div>
            </div>
          </div>

          {/* Main Content */}
          <h1 className="text-white clash-font text-5xl md:text-7xl font-medium mb-6">
            Page Not Found
          </h1>

          <p className="text-white/80 text-lg md:text-2xl max-w-3xl leading-relaxed mb-10 font-light">
            It seems the page you’re looking for doesn’t exist. Let’s get you
            back on track.
          </p>

          <PrimaryBtn
            text="Return to Homepage"
            dark={true}
            iconSrc={Icons?.chevronBlue}
            href="/"
          />
        </div>
        <div className="absolute inset-0 opacity-20 pointer-events-none">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] border border-white/10 rounded-full" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] border border-white/10 rounded-full" />
        </div>
      </section>
    </>
  );
}
